import activityLog from './activityLog'
import address from './address'
import auth from './auth'
import categories from './categories'
import childOrganisations from './childOrganisations/main'
import dashboard from './dashboard/main'
import editor from './editor'
import files from './files'
import formProcesses from './formProcesses/main'
import forms from './forms'
import fundingPrograms from './fundingPrograms/main'
import globalSearch from './globalSearch'
import landing from './landing'
import lifecycleLog from './lifecycleLog'
import mailTemplates from './mailTemplates/main'
import mails from './mails/main'
import menu from './menu'
import news from './news'
import notifications from './notifications'
import organisationUsers from './organisationUsers/main'
import organisations from './organisations/main'
import pageTitle from './pageTitle'
import paymentRuns from './paymentRuns/main'
import payments from './payments/main'
import process from './process/main'
import processes from './processes/main'
import requestLog from './requestLog'
import roles from './roles/main'
import secret from './secret'
import settings from './settings'
import signature from './signature'
import statusNotifications from './statusNotifications/main'
import statuses from './statuses/main'
import table from './table/main'
import testUsers from './testUsers/main'
import userOrganisations from './userOrganisations/main'
import users from './users/main'
import usersFrontend from './usersFrontend/main'
import yearInterviews from './yearInterviews'
import years from './years'

export default {
    localeHint: 'Dies ist die deutsche Version der Website.',
    canNotAccessRoute: 'Sie haben keine Berechtigung, auf diese Seite zu gehen.',

    serverError: 'Es liegt serverseitig ein Fehler vor.',
    serverErrorSupport: 'Dieser Fehler wurde bereits im Hintergrund an den Support gemeldet. Sie helfen uns, wenn Sie kurz beschreiben, in welcher Situation dieser Fehler aufgetreten ist und an oaseaej{\'@\'}farbcode.net senden.',
    serverErrorThankYou: 'Vielen Dank für Ihre Mithilfe.',

    invalidRequestData: 'Die Anfrage enthält ungültige Daten.',
    modelDoesNotExist: 'Die angeforderte Ressource existiert nicht.',
    generalRequestError: 'Die Anfrage konnte nicht verarbeitet werden.',

    baseData: 'Daten',
    pleaseSelect: 'Bitte wählen...',
    noResults: 'Keine Ergebnisse',
    noData: 'Keine Daten',
    required: 'Pflichtfeld',

    resourceDoesNotExist: 'Der aufgerufene Eintrag existiert nicht, oder Sie haben keine Berechtigung diesen abzurufen.',
    confirmLeave: 'Sie haben nicht gespeicherte Änderungen. Möchten Sie die Seite wirklich verlassen?',

    abort: 'Abbrechen',
    close: 'Schließen',
    delete: 'Löschen',
    reset: 'Zurücksetzen',
    back: 'Zurück',
    save: 'Speichern',
    discard: 'Verwerfen',
    error: 'Fehler',
    open: 'Öffnen',
    show: 'Anzeigen',
    more: 'Weiteres',
    change: 'Ändern',
    add: 'Hinzufügen',
    attach: 'Verknüpfen',
    detach: 'Verknüpfung lösen',
    welcome: 'Willkommen!',
    showMore: 'Mehr anzeigen',
    showLess: 'Weniger anzeigen',
    yes: 'Ja',
    no: 'Nein',
    name: 'Name',

    locales: {
        de: 'Deutsch', en: 'English'
    },

    domestic: 'Inland',
    abroad: 'Ausland',

    activityLog,
    address,
    auth,
    categories,
    childOrganisations,
    dashboard,
    editor,
    files,
    formProcesses,
    forms,
    fundingPrograms,
    globalSearch,
    landing,
    lifecycleLog,
    mailTemplates,
    mails,
    menu,
    news,
    notifications,
    organisationUsers,
    organisations,
    pageTitle,
    paymentRuns,
    payments,
    process,
    processes,
    requestLog,
    roles,
    secret,
    settings,
    signature,
    statusNotifications,
    statuses,
    table,
    testUsers,
    userOrganisations,
    users,
    usersFrontend,
    yearInterviews,
    years,
}
